import React, { useState } from "react";

import arrowDown from "../../../assets/icons/arrow-down12.png";
import close from "../../../assets/icons/close-circle.svg";
import arrowUp from "../../../assets/icons/arrow-up.svg";

export default function AudienceFilterItem({
  filterName,
  description,
  children,
  setLocation = undefined,
  identificationFilter = undefined,
  locationFilter = undefined,
  patientHistoryFilter = undefined,
  insuranceFilter = undefined,
  paymentFilter = undefined,
  oralHealthFilter = undefined,
  setIdentificationFilter = undefined,
  setLocationFilter = undefined,
  setPatientHistoryFilter = undefined,
  setInsuranceFilter = undefined,
  setPaymentFilter = undefined,
  setOralHealthFilter = undefined,
}) {
  const [showFilter, setShowFilter] = useState(false);

  function hasFilter() {
    switch (filterName) {
      case "Identification":
        const { first_name, last_name, gender, age, joined_date, birth_date } = identificationFilter;
        return (
          first_name || last_name || gender || age[0] || age[1] || joined_date.lower || joined_date.upper || birth_date.lower || birth_date.upper
        );

      case "Location":
        const { city, state, country, latitude, longitude } = locationFilter;
        return city || state || country || latitude || longitude;

      case "Patient History":
        return patientHistoryFilter.length > 0;

      case "Insurance":
        return insuranceFilter.length > 0;

      case "Payment":
        const { payment_method, payment_plan_amount_range, creation_start_date, creation_end_date, date_range_start, date_range_end } = paymentFilter;
        return (
          payment_method ||
          payment_plan_amount_range[0] ||
          payment_plan_amount_range[1] ||
          creation_start_date ||
          creation_end_date ||
          date_range_start ||
          date_range_end
        );

      case "Oral Health":
        return oralHealthFilter.char_value || oralHealthFilter.integer_value;

      default:
        return false;
    }
  }

  function oralHealthScoreValue(value) {
    switch (value) {
      case 1:
        return "0 < score < 25";
      case 2:
        return "25 < score < 50";
      case 3:
        return "50 < score < 75";
      case 4:
        return "75 < score < 100";
      default:
        return "invalid";
    }
  }

  return (
    <div style={{ padding: "20px 30px", boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)", borderRadius: 10 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 16 }}>{filterName}</span>
        <img
          src={showFilter ? arrowUp : arrowDown}
          alt="filter"
          onClick={() => setShowFilter((filter) => !filter)}
          className="audience-filter-item-hover"
        />
      </div>

      {/* Created filters must be shows if any filter created, otherwise the description */}
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10, marginBottom: showFilter ? 20 : 0, marginTop: 5 }}>
        {!hasFilter() ? (
          <p style={{ fontSize: 16, color: "#979797", marginBottom: 0 }}>{description}</p>
        ) : (
          <>
            {/* Identification */}
            {identificationFilter && (
              <>
                {(identificationFilter.first_name || identificationFilter.last_name) && (
                  <FilterLabel
                    remover={() => setIdentificationFilter((prevStates) => ({ ...prevStates, first_name: "", last_name: "" }))}
                  >{`${identificationFilter.first_name} ${identificationFilter.last_name}`}</FilterLabel>
                )}
                {identificationFilter.gender && (
                  <FilterLabel remover={() => setIdentificationFilter((prevStates) => ({ ...prevStates, gender: "" }))}>
                    {identificationFilter.gender}
                  </FilterLabel>
                )}
                {(identificationFilter.age[0] !== 0 || identificationFilter.age[1] !== 0) && (
                  <FilterLabel
                    remover={setIdentificationFilter}
                  >{`${identificationFilter.age[0]} < Age < ${identificationFilter.age[1]}`}</FilterLabel>
                )}
                {(identificationFilter.joined_date.lower || identificationFilter.joined_date.upper) && (
                  <FilterLabel remover={() => setIdentificationFilter((prevStates) => ({ ...prevStates, joined_date: { lower: "", upper: "" } }))}>
                    {`${identificationFilter.joined_date.lower && `${identificationFilter.joined_date.lower} <`} join date < ${
                      identificationFilter.joined_date.upper && `< ${identificationFilter.joined_date.upper}`
                    }`}
                  </FilterLabel>
                )}
                {(identificationFilter.birth_date.lower || identificationFilter.birth_date.upper) && (
                  <FilterLabel remover={() => setIdentificationFilter((prevStates) => ({ ...prevStates, birth_date: { lower: "", upper: "" } }))}>
                    {`${identificationFilter.birth_date.lower && `${identificationFilter.birth_date.lower} <`} birth date < ${
                      identificationFilter.birth_date.upper && `< ${identificationFilter.birth_date.upper}`
                    }`}
                  </FilterLabel>
                )}
              </>
            )}

            {/* Location */}
            {locationFilter && Object.values(locationFilter).some((value) => value) && (
              <FilterLabel
                remover={() => {
                  setLocationFilter({ city: "", state: "", country: "", latitude: "", longitude: "" });
                  setLocation("");
                }}
              >{`${locationFilter.city} ${locationFilter.country}`}</FilterLabel>
            )}

            {/* Patient History */}
            {/* {patientHistoryFilter &&
              patientHistoryFilter.length > 0 &&
              patientHistoryFilter.map((historyItem, index) => (
                <FilterLabel key={index} filter={`${historyItem.condition} ${historyItem.treatment} ${historyItem.medication}`} />
              ))} */}

            {/* Insurance */}

            {/* Payment */}
            {paymentFilter && (
              <>
                {paymentFilter.payment_method && (
                  <FilterLabel remover={() => setPaymentFilter((prevStates) => ({ ...prevStates, payment_method: "" }))}>
                    {paymentFilter.payment_method}
                  </FilterLabel>
                )}
                {(paymentFilter.payment_plan_amount_range[0] || paymentFilter.payment_plan_amount_range[1]) && (
                  <FilterLabel remover={() => setPaymentFilter((prevStates) => ({ ...prevStates, payment_plan_amount_range: [0.0] }))}>
                    {`$${paymentFilter.payment_plan_amount_range[0]}${paymentFilter.payment_plan_amount_range[0] ? 'K' : ''} < Amount < $${paymentFilter.payment_plan_amount_range[1]}K`}
                  </FilterLabel>
                )}
                {(paymentFilter.creation_start_date || paymentFilter.creation_end_date) && (
                  <FilterLabel remover={() => setPaymentFilter((prevStates) => ({ ...prevStates, creation_start_date: "", creation_end_date: "" }))}>
                    {`${paymentFilter.creation_start_date && `${paymentFilter.creation_start_date} <`} Creation Date ${
                      paymentFilter.creation_end_date && `< ${paymentFilter.creation_end_date}`
                    } `}
                  </FilterLabel>
                )}
                {(paymentFilter.date_range_start || paymentFilter.date_range_end) && (
                  <FilterLabel remover={() => setPaymentFilter((prevStates) => ({ ...prevStates, date_range_start: "", date_range_end: "" }))}>
                    {`${paymentFilter.date_range_start && `${paymentFilter.date_range_start} <`} Payment Date ${
                      paymentFilter.date_range_end && `< ${paymentFilter.date_range_end}`
                    } `}
                  </FilterLabel>
                )}
              </>
            )}

            {/* Oral Health */}
            {oralHealthFilter && (
              <>
                {oralHealthFilter.char_value && (
                  <FilterLabel remover={() => setOralHealthFilter((prevStates) => ({ ...prevStates, char_value: "" }))}>
                    {oralHealthFilter.char_value}
                  </FilterLabel>
                )}
                {oralHealthFilter.integer_value && (
                  <FilterLabel remover={() => setOralHealthFilter((prevStates) => ({ ...prevStates, integer_value: undefined }))}>
                    {oralHealthScoreValue(oralHealthFilter.integer_value)}
                  </FilterLabel>
                )}
              </>
            )}
          </>
        )}
      </div>

      {showFilter && children}
    </div>
  );
}

function FilterLabel({ children, remover }) {
  return (
    <div style={{ padding: "3px 10px", backgroundColor: "#EEEDFA", borderRadius: 100, display: "flex", alignItems: "center", gap: 10 }}>
      <span style={{ color: "#6B43B5", fontSize: 12 }}>{children}</span>
      <img src={close} alt="remove" style={{ cursor: "pointer", width: 15, height: 15 }} onClick={remover} />
    </div>
  );
}
